export interface SsoDiscoverResponse {
  requiresPassword: boolean;
  ssoUrl?: string | null;
  providerName?: string | null;
}

export const SSO_SESSION_CONFLICT = 'session_conflict';

export const SSO_ERROR_MESSAGES: Record<string, string> = {
  idp_unavailable: 'Single sign-on is currently unavailable. Please try again later or contact your administrator.',
  access_denied: 'Single sign-on was cancelled.',
  invalid_response: 'Single sign-on failed. Please try again.',
  user_not_allowed: 'Your account is not allowed to sign in with single sign-on. Please contact your administrator.',
  invalid_request: 'Invalid sign-in request. Please start again from the application.',
};

export const SSO_DEFAULT_ERROR_MESSAGE = 'Single sign-on failed. Please try again.';
